module.exports = __webpack_public_path__ + "static/img/bg_line01.d5a0ef8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/pc/bg_line01.gif
// module id = sU8k
// module chunks = 10